import React from 'react'
import {Link} from 'react-router-dom'

function BlogDetails() {
  return (
    <div>
    <div className="section-bg section-padding subheader"  style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/subheader.jpg)' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <h1 className="text-white page-title">Blog Details</h1>
                </div>
            </div>
        </div>
    </div>
    <section className="section">
        <div className="container">
            <div className="row flex-lg-row-reverse">
                <aside className="col-lg-4">
                    <div className="sidebar">
                        <div className="sidebar_inner">
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Search</h5>
                                <form action="#" method="POST">
                                    <div className="input-group">
                                        <input type="text" name="#" className="form-control form-control-custom" placeholder="Search keywords..." autoComplete="off" required=""/>
                                        <div className="input-group-append">
                                            <button type="submit">
                                                <i className="fal fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Category</h5>
                                <ul className="categories">
                                    <li>
                                        <Link to="/blog-grid">Fitness <span>(267)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Health <span>(50)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Lifestyle <span>(78)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Nutrition <span>(95)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Sport <span>(15)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Science <span>(65)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Training <span>(62)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Program <span>(85)</span></Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Recent Post</h5>
                                <ul className="recent_post">
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/fit2fine/assets/images/blog/1.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">You Will Become As Off Small Your Desire.</Link></h6>
                                            <p className="post_date">20 Fab 2024</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/fit2fine/assets/images/blog/2.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">10 Tips How to Prepare Meals Fast and Easy.</Link></h6>
                                            <p className="post_date">18 Fab 2024</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/fit2fine/assets/images/blog/3.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">How to Maximise Time Spent at the Gym.</Link></h6>
                                            <p className="post_date">15 Fab 2024</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Tags</h5>
                                <div className="tags_cloud">
                                    <Link to="/blog-grid">Fitness </Link>
                                    <Link to="/blog-grid">Health</Link>
                                    <Link to="/blog-grid">Lifestyle</Link>
                                    <Link to="/blog-grid">Nutrition</Link>
                                    <Link to="/blog-grid">Sport</Link>
                                    <Link to="/blog-grid">Science</Link>
                                    <Link to="/blog-grid">Training</Link>
                                    <Link to="/blog-grid">Program</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>
                <div className="col-lg-8">
                    <article className="post post_details mb-0">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/details.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        20 Fab 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                                <li>
                                    <i className="bi-folder2"></i>
                                    <Link to="/blog-grid">
                                        Fitness
                                    </Link>
                                    <Link to="/blog-grid">
                                        Health
                                    </Link>
                                    <Link to="/blog-grid">
                                        Lifestyle
                                    </Link>
                                </li>
                                <li>
                                    <i className="bi-tags"></i>
                                    <Link to="/blog-grid">
                                        Cardio
                                    </Link>
                                    <Link to="/blog-grid">
                                        Crossfit
                                    </Link>
                                    <Link to="/blog-grid">
                                        Strength
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">You Will Become As Off Small Your Desire. </Link>
                            </h2>
                            <div className="post_description">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                                <div className="row">
                                    <div className="col-sm-6 mb-xl-20">
                                        <img src="/tm/react/fit2fine/assets/images/blog/1.jpg" alt="img" className="image-fit"/>
                                    </div>
                                    <div className="col-sm-6 mb-xl-20">
                                        <img src="/tm/react/fit2fine/assets/images/blog/2.jpg" alt="img" className="image-fit"/>
                                    </div>
                                </div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                <blockquote>
                                    <p className="quote_title">Prepare to Take on Everything with Your Hnad.This Session Strips it Back.</p>
                                    <span className="quote_icon"> <i className="fa fa-quote-left"></i> </span>
                                </blockquote>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                            </div>
                            <div className="post_tags_share">
                                <div className="post_share">
                                    <i className="fal fa-share title"></i>
                                    <ul className="social">
                                        <li>
                                            <Link to="#">
                                                <i className="fab fa-facebook-f"></i>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#">
                                                <i className="fab fa-twitter"></i>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#">
                                                <i className="fab fa-instagram"></i>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#">
                                                <i className="fab fa-behance"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="post_tags">
                                    <i className="bi-tags title"></i>
                                    <div className="tags">
                                        <Link to="/blog-grid">
                                            Cardio
                                        </Link>
                                        <Link to="/blog-grid">
                                            Crossfit
                                        </Link>
                                        <Link to="/blog-grid">
                                            Strength
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                  
                    <div className="comment_box thm-bg-color-two px-4 pt-0">
                        <h5 className="bar_title">Reviews [2]</h5>
                        <ul className="comments">
                            <li className="comment">
                                <article>
                                    <div className="comment_image">
                                        <img src="/tm/react/fit2fine/assets/images/team/1.jpg" alt="img" className="image-fit"/>
                                        <button type="button" className="reply_btn thm-btn btn-small thm-bg-color-two">
                                            Reply
                                        </button>
                                    </div>
                                    <div className="comment_text">
                                        <h6 className="title">Anna Deo</h6>
                                        <div className="comment_date">10 Fab 2024</div>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                    </div>
                                </article>
                                <ul className="comments children">
                                    <li className="comment">
                                        <article>
                                            <div className="comment_image">
                                                <img src="/tm/react/fit2fine/assets/images/team/2.jpg" alt="img" className="image-fit"/>
                                                <button type="button" className="reply_btn thm-btn btn-small thm-bg-color-two">
                                                    Reply
                                                </button>
                                            </div>
                                            <div className="comment_text">
                                                <h6 className="title">Jhon Deo</h6>
                                                <div className="comment_date">10 Fab 2024</div>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                            </div>
                                        </article>
                                    </li>
                                </ul>
                            </li>
                            <li className="comment">
                                <article>
                                    <div className="comment_image">
                                        <img src="/tm/react/fit2fine/assets/images/team/3.jpg" alt="img" className="image-fit"/>
                                        <button type="button" className="reply_btn thm-btn btn-small thm-bg-color-two">
                                            Reply
                                        </button>
                                    </div>
                                    <div className="comment_text">
                                        <h6 className="title">Anna Wright</h6>
                                        <div className="comment_date">10 Fab 2024</div>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                    </div>
                                </article>
                            </li>
                        </ul>
                    </div>
                    <div className="comment_form thm-bg-color-two p-4">
                        <h5 className="bar_title">Leave A Reply</h5>
                        <form className="form_style style_two">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <input type="text" name="#" placeholder="Your Full Name" className="form-control form-control-custom" autoComplete="off"/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <input type="email" name="#" placeholder="Your Email" className="form-control form-control-custom" autoComplete="off"/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <textarea rows="5" name="#" placeholder="Write Message" className="form-control form-control-custom" autoComplete="off"></textarea>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <button type="submit" className="thm-btn w-100">
                                        Leave Comment
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default BlogDetails